import React from "react";
import { useTheme } from "libs/shared/hooks/use-theme.js"

const DomainCustomerNode = ({ data, selected, className, ...props }) => (
  <div className={`p-4 rounded-lg border ${className}`}>
    <h3 className="text-lg font-semibold mb-2">{data.label}</h3>
    {data.description && (
      <p className="text-sm text-gray-500">{data.description}</p>
    )}
    {data.customerInfo && (
      <div className="mt-2 text-sm">
        <div><strong>Name:</strong> {data.customerInfo.name}</div>
        <div><strong>Email:</strong> {data.customerInfo.email}</div>
        {data.customerInfo.phone && (
          <div><strong>Phone:</strong> {data.customerInfo.phone}</div>
        )}
      </div>
    )}
  </div>
);

export function CustomerNode({ data, selected, ...props }) {
  const { theme } = useTheme();

  return (
    <div className={`${selected ? "ring-2 ring-purple-500" : ""}`}>
      <DomainCustomerNode
        data={data}
        selected={selected}
        className={`bg-${theme === "dark" ? "neutral-800" : "white"} border-${theme === "dark" ? "neutral-700" : "gray-200"
          }`}
        {...props}
      />
    </div>
  );
}
